'use strict';

exports.__esModule = true;
var ImageResizeMode = {
  center: 'center',
  contain: 'contain',
  cover: 'cover',
  none: 'none',
  repeat: 'repeat',
  stretch: 'stretch'
};

exports.default = ImageResizeMode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/cjs/exports/Image/ImageResizeMode.js
// module id = 1028
// module chunks = 0